<template>
  <div class="basicPortContent">
    <!--loading-->
    <loading v-show="isLoading" />
    <!--el-from-->
    <div class="serachBack">
      <el-form
        ref="ruleForm"
        size="mini"
        label-position="right"
        :model="ruleForm"
      >
        <div class="searhContent">
          <el-form-item prop="str" style="display: inline-block; width: 200px">
            <el-input
              v-model="ruleForm.str"
              placeholder="请输入搜索内容"
              maxlength="100"
              @input="handleInputClick"
            />
          </el-form-item>
          <span
            style="
              color: red;
              font-size: 14px;
              margin-left: 20px;
              margin-right: 20px;
            "
            >数据来源：船期数据</span
          >
          <el-checkbox v-model="ruleForm.isNotMatch" @change="checkChange">
            未匹配
          </el-checkbox>
          <el-checkbox v-model="ruleForm.hideInvalidShip" @change="checkChange">
            隐藏无效船舶
          </el-checkbox>
          <el-checkbox v-model="ruleForm.hidebarge" @change="checkChange">
            隐藏驳船
          </el-checkbox>
        </div>
        <div style="clear: both"></div>
      </el-form>
    </div>
    <!--el-table-->
    <div class="tablePage">
      <el-table
        ref="table"
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#3bafda',
          color: '#ffffff',
          fontSize: '12px',
        }"
        :row-class-name="tabRowClassName"
        tooltip-effect="dark"
        @row-dblclick="currentChange"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="45" />
        <el-table-column
          prop="carrier"
          label="船公司"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="100"
        />
        <el-table-column
          prop="nameEn"
          label="船名"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="140"
        />
        <el-table-column
          prop="standardNameEn"
          label="标准船名"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="140"
        />
        <el-table-column
          prop="category"
          label="类别"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="140"
        >
          <template slot-scope="scope">
            <div class="sel-el">
              <el-select
                v-model="scope.row.category"
                clearable
                @change="() => updateCategory(scope.row)"
                @clear="() => updateCategory(scope.row)"
              >
                <el-option
                  v-for="c of categories"
                  :key="c.id"
                  :value="c.id"
                  :label="c.value"
                >
                  {{ c.value }}
                </el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="state"
          label="状态"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="140"
        >
          <template slot-scope="scope">
            <div class="sel-el">
              <el-select
                v-model="scope.row.state"
                @change="() => updateState(scope.row)"
              >
                <el-option
                  v-for="c of states"
                  :key="c.id"
                  :value="c.id"
                  :label="c.value"
                >
                  {{ c.value }}
                </el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="mmsi"
          label="MMSI"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="140"
        />
        <el-table-column
          prop="imo"
          label="IMO"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="100"
        />
        <el-table-column
          prop="updateUser"
          label="操作人"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.updateUser ? scope.row.updateUser.toUpperCase() : '' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="142"
        />
        <el-table-column
          prop="updateTime"
          label="操作时间"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="142"
        />
        <template slot="empty">
          <noData />
        </template>
      </el-table>
      <!--分页-->
      <ThePagination
        ref="refPagination"
        :page-number="pageNumber"
        :attribute="paginationAttribute"
        class="refPagination"
      />
    </div>
    <el-dialog
      v-if="shipMent"
      ref="shipMent"
      class="shipMent"
      :visible.sync="shipMent"
      width="1100px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <shipAdd
        ref="basicShipAdd"
        :ship-manag="shipManag"
        :vessel-id="vesselId"
        :origin="origin"
        @closeShipInfor="handleClose"
        @updatShip="updatShip"
      />
    </el-dialog>
  </div>
</template>

<script>
import shipAdd from './shipAdd.vue'
import ThePagination from '@/components/ThePagination/ThePagination.vue'
import loading from '@/components/Loading/outLoading.vue'
import noData from '@/components/noData/index.vue'
export default {
  components: {
    ThePagination,
    loading,
    shipAdd,
    noData,
  },
  data() {
    return {
      categories: [
        {
          id: 1,
          value: '驳船',
        },
        {
          id: 2,
          value: '国际集装箱船',
        },
      ],
      states: [
        {
          id: 0,
          value: '无效',
        },
        {
          id: 1,
          value: '有效',
        },
      ],
      matched: '',
      isLoading: true,
      sortableState: true,
      shipMent: false,
      origin: 1, //船期船舶
      shipManag: '',
      vesselId: '',
      ruleForm: {
        str: '',
        isNotMatch: true,
        hideInvalidShip: true,
        hidebarge: false,
      },
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      // 引用 ThePagination组件
      refPagination: {},
      paginationAttribute: {
        handleChange: this.handleChange,
      },
      //分页默认状态
      pageNumber: -1,
      page: {
        // 当前页数
        pageNo: 1,
        // 每页默认显示条数
        pageSize: 10,
        // 总条数
        total: 0,
      },
      handleSelection: [],
      companyNameList: [],
    }
  },
  mounted() {
    this.matched = this.$route.matched
    this.ruleForm.isNotMatch = true
    this.searchList()
    this.$bus.on('clickMenu', content => {
      if (
        Math.ceil(this.tableData.length / this.page.pageSize) < this.page.pageNo
      ) {
        this.page.pageNo = 1
        this.pageNumber = 1
      }
      this.$refs.table.clearSort()
      this.ruleForm.str = ''
      this.searchList()
    })
  },
  destroyed() {
    this.$bus.off('clickMenu')
  },
  methods: {
    async updateState(row) {
      this.isLoading = true
      try {
        const resp = await this.$axios.post(
          this.commonJs.localUrl +
            `/schedules/baseVessel/updateScheduleShipCollectState`,
          null,
          {
            params: {
              id: row.vesselId,
              state: row.state,
            },
            headers: {
              Authorization: `Bearer ${this.getAuthorization()}`,
              AccessToken: this.getCookie('token'),
            },
          }
        )

        if (resp.data.status !== 1) {
          this.$message.error('修改失败')
        } else {
          await this.searchList()
        }
      } finally {
        this.isLoading = false
      }
    },

    async updateCategory(row) {
      this.isLoading = true
      try {
        const resp = await this.$axios.post(
          this.commonJs.localUrl +
            `/schedules/baseVessel/updateScheduleShipCollectCategory`,
          null,
          {
            params: {
              id: row.vesselId,
              category: row.category || 0,
            },
            headers: {
              Authorization: `Bearer ${this.getAuthorization()}`,
              AccessToken: this.getCookie('token'),
            },
          }
        )

        if (resp.data.status !== 1) {
          this.$message.error('修改失败')
        } else {
          await this.searchList()
        }
      } finally {
        this.isLoading = false
      }
    },
    //输入查询列表
    handleInputClick(value) {
      if (
        Math.ceil(this.tableData.length / this.page.pageSize) < this.page.pageNo
      ) {
        this.page.pageNo = 1
        this.pageNumber = 1
      }
      setTimeout(() => {
        this.isLoading = true
        this.$refs.table.clearSort()
        this.$axios
          .get(this.commonJs.localUrl + `/schedules/baseVessel/vesselList`, {
            params: {
              isMatch: this.ruleForm.isNotMatch ? '1' : '0',
              pageNumber: this.page.pageNo,
              pageSize: this.page.pageSize,
              origin: this.origin || '',
              str: value || '',
              hideInvalidShip: this.ruleForm.hideInvalidShip ? 1 : 0,
              hidebarge: this.ruleForm.hidebarge ? 1 : 0,
            },

            //船期船舶
            headers: {
              Authorization: `Bearer ${this.getAuthorization()}`,
              AccessToken: this.getCookie('token'),
            },
          })
          .then(res => {
            if (res.data.status == 1) {
              this.tableData = res.data.content
              this.$refs.refPagination.page.total = res.data.total
              this.$refs.refPagination.changeValue()
              this.isLoading = false
            } else {
              this.$message({
                type: 'error',
                message: '数据加载失败 请重新加载页面',
              })
            }
          })
      }, 500)
    },
    //搜索 (页面初始化)
    searchList(reload) {
      this.isLoading = true
      this.$refs.table.clearSort()
      this.$axios
        .get(this.commonJs.localUrl + `/schedules/baseVessel/vesselList`, {
          //船期船舶
          params: {
            isMatch: this.ruleForm.isNotMatch ? '1' : '0',
            pageNumber: this.page.pageNo,
            pageSize: this.page.pageSize,
            origin: this.origin || '',
            str: this.ruleForm.str || '',
            hideInvalidShip: this.ruleForm.hideInvalidShip ? 1 : 0,
            hidebarge: this.ruleForm.hidebarge ? 1 : 0,
          },
          headers: {
            Authorization: `Bearer ${this.getAuthorization()}`,
            AccessToken: this.getCookie('token'),
          },
        })
        .then(res => {
          if (res.data.status == 1) {
            if (res.data.content !== '') {
              if (res.data.content.length <= 0) {
                this.tableData = []
                if (this.$refs.refPagination) {
                  this.$refs.refPagination.page.total = res.data.total
                  this.$refs.refPagination.changeValue()
                }
              } else {
                if (res.data.status == 1) {
                  this.tableData = []
                  this.tableData = res.data.content
                  if (this.$refs.refPagination) {
                    this.$refs.refPagination.page.total = res.data.total
                    this.$refs.refPagination.changeValue()
                  }
                }
                if (this.$refs.refPagination) {
                  if (
                    Math.ceil(
                      this.$refs.refPagination.page.total / this.page.pageSize
                    ) < this.page.pageNo
                  ) {
                    this.$refs.refPagination.handleCurrentChange(1)
                  }
                }
              }
            }
            this.isLoading = false
          } else if (res.data.status == 0) {
            this.$message({
              type: 'error',
              message: '数据加载失败 请重新加载页面',
            })
          }
        })
    },
    //给分页传的属性
    handleChange(params) {
      this.isLoading = true
      this.page.pageSize = params.pageSize
      this.page.pageNo = params.pageNo
      this.searchList()
      this.pageNumber = -1
    },
    //表格的斑马线
    tabRowClassName({ row, rowIndex }) {
      row.index = rowIndex
      let index = rowIndex + 1
      if (index % 2 !== 0) {
        return 'warning-row'
      }
    },
    //全选
    handleSelectionChange(val) {
      this.handleSelection = val
    },
    //关闭事件
    handleClose() {
      this.shipMent = false
    },
    updatShip() {
      this.searchList()
    },
    //双击列表行
    currentChange(row) {
      this.shipMent = true
      this.shipManag = '修改'
      this.vesselId = row.vesselId
    },
    //是否匹配
    checkChange() {
      this.$refs.refPagination.handleCurrentChange(1)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep.el-row .el-col:nth-last-of-type(1) {
  margin-right: 0;
}

::v-deep .el-col {
  margin-right: 20px;
}

::v-deep .refPagination input {
  width: 100px !important;
}

::v-deep.el-table th,
::v-deep.el-table tr {
  height: 30px;
}

::v-deep.el-table th {
  height: 30px;
  padding: 0;
}

::v-deep.el-table__empty-text {
  width: 100%;
}

::v-deep.el-table .cell {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

::v-deep.el-table .caret-wrapper {
  height: 23px;
}

::v-deep.el-table .sort-caret.ascending {
  top: 0px;
}

::v-deep.el-table .sort-caret.descending {
  bottom: 1px;
}

.tablePage ::v-deep.el-icon-arrow-down::before {
  color: red;
  display: none;
  margin-left: -10px;
  height: 0;
}

::v-deep.el-table__column-filter-trigger {
  width: 0;
  height: 0;
}

::v-deep .el-table .warning-row {
  background: rgba(241, 245, 247, 1) !important;
}

::v-deep .el-table .warning-row:hover {
  background: rgba(241, 245, 247, 1);
}

.shipMent {
  overflow: hidden;
}

.basicPortContent {
  position: relative;
  overflow: hidden;
  padding: 20px 20px 20px 20px;
  overflow: hidden;

  .serachBack {
    background-color: #fff;
    padding: 20px 20px 0px 20px;
    position: relative;
  }

  .tablePage {
    background-color: #fff;
    padding: 0px 20px 20px 20px;
  }

  .refPagination {
    width: 100%;
    background-color: #fff;
  }
}

.contentLeft {
  float: left;
  width: 90%;
}

.contenRight {
  position: absolute;
  right: 20px;
  bottom: 5px;
}

.serachBtn {
  padding: 9px 35px;
  color: #fff;
  background-color: rgba(4, 153, 255, 1);
  margin-bottom: 10px;
  border: 1px solid #3bafda;
}

.clickColor {
  background-color: #fff;
  padding: 9px 27px;
  margin-right: 10px;
}

.butn {
  margin-right: 0;
  background-color: #ff9000;
  color: #fff;
  padding: 9px 35px;
  float: right;
  margin-bottom: 20px;
}

.butnDele {
  margin-right: 10px;
  border: 1px solid #ff0000;
  color: #ff0000;
  padding: 9px 35px;
  float: right;
  margin-bottom: 20px;
}
.sel-el {
  overflow: hidden;
  width: 100%;
  height: 28px;
}

.sel-el ::v-deep .el-input__inner {
  height: 28px;
  line-height: 28px;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 10px;
}

.sel-el ::v-deep .el-input__icon {
  line-height: 28px;
}

.sel-el ::v-deep .el-input__suffix {
  right: 0;
}
</style>
